import { Button } from '../../components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Lock, Loader2 } from 'lucide-react';
import { SimulationView } from './SimulationView';

export function SimulationDialog({ 
    open, 
    onOpenChange, 
    selectedComm, 
    simResult, 
    canValidate, 
    validating, 
    onValidate 
}) {
    const showValidateBtn = canValidate && 
        selectedComm?.statut === 'draft' && 
        simResult?.simulation?.is_valid;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-3xl">
                <DialogHeader>
                    <DialogTitle>Simulation - {selectedComm?.dossier_name}</DialogTitle>
                </DialogHeader>
                {simResult && <SimulationView data={simResult.simulation} />}
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>Fermer</Button>
                    {showValidateBtn && (
                        <Button 
                            onClick={onValidate} 
                            disabled={validating} 
                            className="bg-emerald-600"
                            data-testid="validate-commission-btn"
                        >
                            {validating && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
                            <Lock className="w-4 h-4 mr-2" />
                            Valider
                        </Button>
                    )}
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
